import type { ReactNode, MouseEvent } from 'react';
import Hyperlink from '@classify/react-core-components/Hyperlink';

import { getButtonLinkProps } from '@openclassrooms/routing';

import FooterItem from './FooterItem';

interface Props {
  children: ReactNode;
  path?: string;
  rawPath?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  isSmall?: boolean;
}

export default function FooterLinkItem({ children, path, rawPath, onClick, isSmall }: Props) {
  const target = path?.startsWith('http') ? '_blank' : undefined;
  const linkProps = path ? getButtonLinkProps(path) : { href: rawPath ?? '#' };
  return (
    <FooterItem component="li">
      <Hyperlink
        {...linkProps}
        target={target}
        onClick={onClick}
        underline="none"
        variant="small"
        sx={{
          whiteSpace: 'inherit',
          fontSize: isSmall ? '0.8rem' : undefined,
          color: 'text.primary',
          fontWeight: 'normal',
          '&:hover': {
            textDecoration: 'none',
          },
        }}
      >
        {children}
      </Hyperlink>
    </FooterItem>
  );
}
